<template>  
  <div class="main">
    <div class="alarmText">
      预警（以下是超过预警的电表）
    </div>
    <!-- <div class="addAlarm" @click="dialogFormVisible = true">
      +预警设置
    </div> -->
    <el-button class="addAlarm" icon="el-icon-plus" @click="dialogFormVisible = true">预警设置</el-button>
    <!--预警设置弹框-->
    <el-dialog title="预警设置"  :visible.sync="dialogFormVisible">
      <div>
        <!-- <div class="content"> -->
          <el-form ref="form" :model="alarmInfo" label-width="100px">
            <el-form-item label="功率预警值">
              <el-input v-model="alarmInfo.alarmPower"></el-input>
            </el-form-item>
            <el-form-item label="电流预警值">
              <el-input v-model="alarmInfo.alarmAmpere"></el-input>
            </el-form-item>
            <el-form-item label="预警手机号">
              <div class="inputDeposit clearfix" v-for="(item, index) in alarmInfo.alarmPeople" :key="index">
                <div class="alarmPhone">
                  <el-input  v-model="alarmInfo.alarmPeople[index]"></el-input>
                </div>
                <div class="editIcon">
                  <svg class="icon" aria-hidden="true" @click="deletePhone(index)">
                    <use xlink:href="#icon-delete-f73f44"></use>
                  </svg>
                </div>
              </div>
              <div class="inputDeposit clearfix" >
                <div class="alarmPhone">
                  <el-input  v-model="alarmInfo.addPhone"></el-input>
                </div>
                <div class="editIcon">
                  <svg class="icon" aria-hidden="true" @click="addAlarmPhone()">
                    <use xlink:href="#icon-add1"></use>
                  </svg>
                </div>
              </div>
            </el-form-item>
          </el-form>
          
        <!-- </div> -->
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addAlarmSetting">确 定</el-button>
      </div>
    </el-dialog>

  </div>

</template>

<script>
  import * as powerControl from "../../../../../static/js/powerControl.js";

  export default {
    name: 'AlarmSetting',
    data() {
      return {
        alarmInfo:{
          alarmPower: 0,
          alarmAmpere: 0,
          alarmPeople: [],
          addPhone:'',
        },
        buildingID: '001',
        dialogFormVisible:false,
      }
    },
    mounted: async function() {
      this.buildingID = this.$store.state.buildingID;
      let alarmInfoList = await powerControl.getAlarmInfo(this.buildingID);
      alarmInfoList = alarmInfoList.body.alarmInfo;
      if(alarmInfoList==undefined){
        return
      }else{
        this.alarmInfo = alarmInfoList;
      }

    },
    methods: {
      // 增加报警设置
      async addAlarmSetting() {
        this.dialogFormVisible = false;
        this.alarmInfo.alarmPeople.push(this.alarmInfo.addPhone);
        // console.log('alarmInfo: ',this.alarmInfo);
        await powerControl.modifyAlarmInfo(this.buildingID, this.alarmInfo);
        this.alarmInfo.addPhone = '';
      },
      // 删除电话
      deletePhone(index) {
        this.alarmInfo.alarmPeople.splice(index, 1);
      },
      // 添加电话
      addAlarmPhone() {
        this.alarmInfo.alarmPeople.push(this.alarmInfo.addPhone);
        this.alarmInfo.addPhone = '';
      }
    },
    watch: {
      // 监听vuex的值变化
      "$store.state.buildingID":async function(newVal, oldVal) {
        this.buildingID = newVal;
        let alarmInfoList =await powerControl.getAlarmInfo(this.buildingID);
        alarmInfoList = alarmInfoList.body.alarmInfo;
        this.alarmInfo = alarmInfoList;
      }
    },
    props: []
  }
</script>

<style lang="scss" scoped>
.main {
  width:100%;
  height: 100%;
  background-color:#66b1ff;
  border:0.1px solid #66b1ff;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
}
.alarmText {
  font-size: 1em;
  font-weight: bold;
}
.addAlarm {
  color: #66b1ff;
}
.choose {
  width:600px; 
  height:50px; 
}
.content {
  width:400px; 
  float:left; 
}
.explain {
  width:200px; 
  float:left; 
}
.inputDeposit {
  width: 300px;
}
.alarmPeopleTitle {
  float: left;
}
.alarmPeopleList {
  float: left;
  margin-left: 3%;
}
.alarmPhone {
  float: left;
  margin-bottom: 3%;
}
.editIcon {
  float: left;
  margin-left: 3%;
}
.icon {
  width: 1.2em; 
  height: 1.2em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
.clearfix::after {
  content: ''; 
  display: block; 
  clear: both;
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CEnergyManage/BuildingInfo/AlarmSetting.vue